import React, { useState, useEffect } from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import { authFetch } from '../../utils/auth';

const EditConversationPopup = ({ conversationId, onClose, onUpdateConversation }) => {
  const [newTitle, setNewTitle] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    const fetchConversationTitle = async () => {
      try {
        const response = await authFetch(`/conversations/${conversationId}`);
        if (response.ok) {
          const conversation = await response.json();
          setNewTitle(conversation.title);
        } else {
          console.error('Failed to fetch conversation title');
        }
      } catch (error) {
        console.error('Error fetching conversation title:', error);
      }
    };

    fetchConversationTitle();
  }, [conversationId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await authFetch(`/conversations/${conversationId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ title: newTitle }),
      });
      if (response.ok) {
        const updatedConversation = await response.json();
        onUpdateConversation(updatedConversation);
        onClose();
      } else {
        console.error('Failed to update conversation title');
      }
    } catch (error) {
      console.error('Error updating conversation title:', error);
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-20 bg-backdrop/70 backdrop-blur-sm flex items-center justify-center z-50" onClick={handleOverlayClick}>
      <div className="bg-[#FCFCF9] shadow-md p-10 rounded-lg max-w-md w-full relative z-60" onClick={(e) => e.stopPropagation()}>
        <h2 className="text-xl font-bold mb-4">{t('editConversationPopup.title')}</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={newTitle}
            onChange={(e) => setNewTitle(e.target.value)}
            placeholder={t('editConversationPopup.titlePlaceholder')}
            className="w-full p-2 mb-4 border rounded"
            required
          />
          <div className="flex justify-end space-x-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 transition-colors"
            >
              {t('editConversationPopup.cancel')}
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-[#E79469] text-[#1E1A1A] rounded"
            >
              {t('editConversationPopup.update')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditConversationPopup;
